<template>
  <div id="banner">
    <div>
      <div class="bg-header-home">
        <div class="col-lg-12 tx-home-header">
          <!--
          <h5 class="tx-header1 tx-black animated fadeIn slow">THAIVIVAT INSURANCE</h5>
          <h1 class="tx-header2 animated fadeInLeft ">
            <span class="tx-black">"</span> Caring is Giving<span class="tx-black">,,</span>
          </h1>
            -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
}
</script>

<style lang="scss"></style>
